<p *ngIf="fieldLabel">{{ fieldLabel }}</p>
<ng-container *ngIf="form.get(fieldName) || fieldControl as f">
    <div *ngFor="let choice of choices; let i = index" [class.is-invalid]="f.invalid" class="form-check form-check-inline">
        <boolean-checkbox-input
            [formControl]="f | toFormControl"
            [inputId]="fieldName + '_' + i"
        ></boolean-checkbox-input>
        <label class="form-check-label" for="{{ fieldName }}_{{ i }}">{{ choice.key }}</label>
    </div>
    <div field-errors [control]="f"></div>
</ng-container>
